import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-lantaarnpaal',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconLantaarnpaal {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M4.38 10.08 3 8.7l2.3-2.3c.44.49.98.9 1.59 1.17zm6.53-2.06H8.95v3.95h1.95V8.01Zm3.61-1.67c-.44.5-.97.9-1.57 1.19l2.54 2.54 1.38-1.38zM10.99 33H17V22l1-2V5.5A2.5 2.5 0 0 0 15.5 3H14c0 1.65-1.34 3-3 3H9a3 3 0 0 1-3-2.99V0h9.43c4.57 0 5.5 2 5.5 5.5L21 20l1 2v11h6v3H10.99zm.94-31h-4v1c0 .55.45 1 1 1h2c.55 0 1-.45 1-1z"/>
</svg>

    );
  }
}
